'use client'

import { BoxedText } from "./boxedText"
import { download, introduce, iterms, privacy, security } from './util'
import PopupWrapper from './components/PopupWrapper'

export default function Features(props) {
  return (
    <> <section className="relative flex flex-col  items-center bg-contain  bg-no-repeat" >
      <div className='h-[177px]'>
      </div>
      <div className='w-[1200px] h-[563px] relative ' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/page3_1.png)`, backgroundSize: "cover" }}>
        <div className='relative left-[495px] h-[518px]  overflow-auto w-[730px]  [&::-webkit-scrollbar]:hidden  ' ref={props.textFlowRef} style={{ zIndex: '99' }}> <img src={`${process.env.PUBLIC_URL}/images/chat_content.png`} alt=""></img> </div>
      </div>
      <div className='h-[120px]'>
      </div>
      <div className='w-[1200px] h-[1680px]' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/page3_2_v3.png)`, backgroundSize: "cover" }}>
      </div>
      <div className='h-[193px]'>
      </div>
    </section>
      <section className="relative flex flex-col items-center bg-cover w-screen h-1080" >
        <div className="h-[206px]"></div>
        <div className="max-w-3xl mx-auto text-center ">
          <h2 className="font-sans font-normal font-XXType font-400 text-white text-4xl md:text-5xl leading-14 md:leading-16">更多功能敬请期待</h2>
        </div>
        <div className="h-[116px]"></div>
        {/* Items */}
        <div className="flex flex-row ">
          {/* 1st item */}
          <div className="flex flex-col items-center 2xl:w-[375px] h-[338px] bg-black-200 rounded-2xl mr-6 md:max-w-1800  md:w-[300px]">
            <div className="h-[52px]"></div>
            <div className="h-[120px] w-[120px] bg-no-repeat bg-cover relative" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/mj.png)` }}>
            </div>
            <div className="h-[27px]"></div>
            <div className="text-center text-white text-xl font-normal leading-8">Image Bot</div>
            <div className="h-[20px]"></div>
            <div className="md:max-w-1800  md:w-[236px] 2xl:w-[295px] text-center font-normal text-sm leading-5 text-gray-400">图片机器人是一款智能绘画工具，只要输入你想到的文字，就能通过人工智能产出相对应图片</div>
          </div>
          {/* 2nd item */}
          {/* <div className="flex flex-col items-center 2xl:w-[375px] h-[338px] bg-black-200  rounded-2xl mr-6 md:max-w-1800  md:w-[300px]">
            <div className="h-[52px]"></div>
            <div className="h-[120px] w-[120px] relative  bg-no-repeat bg-cover relative" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/ai.png)` }}>
            </div>
            <div className="h-[27px]"></div>
            <div className="text-base font-normal leading-6 text-center text-white text-xl font-normal leading-8">Chat Bot</div>
            <div className="h-[20px]"></div>
            <div className="2xl:w-[295px] md:max-w-1800  md:w-[236px] text-center font-normal text-sm leading-5 text-gray-400">智能聊天机器人高效的效据处理能力、強大的自
              学习能力，为用户提供更好的聊天体验</div>
          </div> */}
          {/* 3rd item */}
          {/* <div className="flex flex-col items-center 2xl:w-[375px] h-[338px] bg-black-200  rounded-2xl mr-6 md:max-w-1800  md:w-[300px]" >
            <div className="h-[52px]"></div>
            <div className="h-[120px] w-[120px] relative  bg-no-repeat bg-cover relative" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/robot.png)` }}>
            </div>
            <div className="h-[27px]"></div>
            <div className="text-base font-normal leading-6 text-center text-white text-xl font-normal leading-8">Music Bot</div>
            <div className="h-[20px]"></div>
            <div className="2xl:w-[295px] md:max-w-1800  md:w-[236px] text-center font-normal text-sm leading-5 text-gray-400">用户可以通过Music Bot来在操作台中发布指令来播放音乐给频道中的用户 </div>
          </div> */}
          {         /* 3rd item */}
          <div className="flex flex-col items-center  2xl:w-[375px] h-[338px] bg-black-200  rounded-2xl md:max-w-1800  md:w-[300px]">
            <div className="h-[52px]"></div>
            <div className="h-[120px] w-[120px] relative  bg-no-repeat bg-cover" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/person.png)` }}>
            </div>
            <div className="h-[27px]"></div>
            <div className="text-center text-white text-xl font-normal leading-8">PDA</div>
            <div className="h-[20px]"></div>
            <div className="2xl:w-[295px] md:max-w-1800  md:w-[236px] text-center font-normal text-sm leading-5 text-gray-400">智能虚拟助手，为用户提供各种服务和支持，如提供游戏出装思路、游戏攻略和情感建议等</div>
          </div>
        </div>
        <div className="h-[129px]"></div>
        <div className="h-[238px] flex items-center justify-center">
          <div className="flex flex-col"> <div className="flex flex-row  font-normal font-medium:font-xx-type text-sm leading-6 color-white text-white">
            <PopupWrapper child={<BoxedText onClick={download}>下载客户端</BoxedText>} /><div className="w-[72px]"></div><BoxedText onClick={iterms}>服务协议</BoxedText><div className="w-[72px]"></div><BoxedText onClick={privacy}>隐私政策</BoxedText><div className="w-[72px]"></div><BoxedText onClick={introduce}>产品介绍</BoxedText>
          </div>
            <div className="h-[31px]"></div>
            <div className="flex items-center w-[695px] justify-between">
              <div className="font-normal text-xs leading-6 text-gray-200">Oopz是绍兴未来山海科技有限公司旗下的一款集语音开黑、社区交友于一体的游戏语音软件，为用户提供便捷高效的游戏语音方式和清晰稳定的通话质量，无任何广告，专注于服务游戏玩家的沉浸式开黑，带给用户超预期的使用体验。</div>
            </div>
            <div className="h-[12px]"></div>
            <div className="grid grid-cols-2 w-[692px]">
              <div className="font-normal text-xs leading-4 text-gray-200">
                Copyright© 2022~ 绍兴未来山海科技有限公司
              </div>

              <div className="text-xs text-left">
                <BoxedText
                  defaultColor="#606060"
                  className="font-normal text-sm leading-4 text-gray-200 cursor-pointer"
                  onClick={() => window.open('https://beian.miit.gov.cn')}
                >
                  浙ICP备2022009362号-5
                </BoxedText>
              </div>
            </div>
            <div className="grid grid-cols-2 w-[692px]">
              <div className="text-xs">
                <div className="font-normal text-xs leading-4 text-gray-200">
                  浙网文(2025)0006-006号
                </div>
              </div>
              <div className="font-normal text-xs leading-4 text-gray-200 text-left">
                增值电信业务经营许可证：浙B2-20220813
              </div>

            </div>
            <div className="h-[12px]"></div>
            <div className="flex flex-row  w-[695px]" style={{ justifyContent: "space-between" }}>
              <div className="flex items-center  w-[695px]" style={{ justifyContent: "space-between" }}>
                <div className="font-normal text-xs leading-4 text-gray-200">公司地址：浙江省绍兴市柯桥区齐贤街道泽宇大厦1幢1803室</div>
                <div className="font-normal text-xs leading-4 text-gray-200">联系方式：18806752513</div>
                <div className="font-normal text-xs leading-4 text-gray-200 flex flex-row items-center w-[207px]">
                  <img alt="111" src={`${process.env.PUBLIC_URL}/images/publicSecurity.png`} />
                  <div className="w-[8px]"></div>
                  <BoxedText onClick={security} defaultColor="#606060">浙公网安备33060302001220号</BoxedText>
                </div>
              </div>
            </div>
            <div className="h-[26px]"></div>
          </div>
          <div className="w-[613px]"></div>
          <img className="w-[290px] h-[128px]" src={`${process.env.PUBLIC_URL}/images/logo_da.svg`} alt="logo"></img>
        </div>
      </section>
    </>

  )
}